var RTL_LANGUAGES = ['ar', 'fa', 'he'];
var LanguageState = /** @class */ (function () {
    function LanguageState(locale) {
        this.currentLanguage = this.getCurrentLanguageFromLocale(locale);
    }
    LanguageState.prototype.getCurrentLanguageFromLocale = function (locale) {
        return (locale === null || locale === void 0 ? void 0 : locale.substring(0, 2)) || 'en';
    };
    LanguageState.prototype.getCurrentLanguage = function () {
        return this.currentLanguage;
    };
    LanguageState.prototype.setCurrentLanguage = function (locale) {
        this.currentLanguage = this.getCurrentLanguageFromLocale(locale);
    };
    LanguageState.prototype.isViewDirectionRtl = function () {
        return RTL_LANGUAGES.indexOf(this.getCurrentLanguage()) > -1;
    };
    return LanguageState;
}());
export { LanguageState };
//# sourceMappingURL=languageState.js.map